export default function delayLoadFont() {
  const style = document.createElement('style');
  style.innerText = `
  @font-face {
    font-family: 'MiSans-Regular';
    src: url(${require('./fonts/MiSans-Regular.woff2')}) format('truetype');
    font-display: swap;
  }
    @font-face {
    font-family: 'MECHABREAKBOLD-1.08';
    src: url(${require('./fonts/MECHABREAKBOLD-1.08.ttf')}) format('truetype');
    font-display: swap;
  }

   @font-face {
      font-family: 'SourceHanSansTWHK-Normal';
      src: url(${require('./fonts/SourceHanSansTWHK-Normal.otf')}) format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'MECHABREAK-regular';
      src: url(${require('./fonts/MECHABREAKregular-1.08.ttf')}) format('truetype');
      font-display: swap;
    }

     @font-face {
      font-family: 'Tomorrow-Thin';
      src: url(${require('./fonts/Tomorrow-Thin.ttf')}) format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'SourceHanSans-Normal';
      src: url(${require('./fonts/SourceHanSans-Normal.otf')}) format('truetype');
      font-display: swap;
    }

     @font-face {
      font-family: 'MECHABREAK-regular';
      src: url(${require('./fonts/MECHABREAKregular-1.08.ttf')}) format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'Tomorrow-Thin';
      src: url(${require('./fonts/Tomorrow-Thin.ttf')}) format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'SourceHanSansKR-Normal';
      src: url(${require('./fonts/SourceHanSansKR-Normal.otf')}) format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'MECHABREAK-regular';
      src: url(${require('./fonts/MECHABREAKregular-1.08.ttf')}) format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'Tomorrow-Thin';
      src: url(${require('./fonts/Tomorrow-Thin.ttf')}) format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'Anuphan-Normal';
      src: url(${require('./fonts/Anuphan-Regular.ttf')}) format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'MECHABREAK-regular';
      src: url(${require('./fonts/MECHABREAKregular-1.08.ttf')}) format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'MiSans-Semibold';
      src: url(${require('./fonts/MiSans-Semibold.woff2')}) format('truetype');
      font-display: swap;
    }
     @font-face {
      font-family: 'Tomorrow-Thin';
      src: url(${require('./fonts/Tomorrow-Thin.ttf')}) format('truetype');
      font-display: swap;
    }

  `;
  document.head.appendChild(style);
}
